import { Injectable, ComponentRef } from '@angular/core';

import { ModalDialogOverlayComponent } from './modal-dialog-overlay.component';
import { ModalDialogContentRef } from './modal-dialog-utils';
import { ModalDialogWindowComponent } from './modal-dialog-window.component';

@Injectable()
export class ModalDialogActive<T, V = string> {
    close(_?: T | 'cancel'): void {}
    dismiss(_?: V): void {}
}

@Injectable()
export class ModalDialogRef<ClosedWithType, DialogType> {
    private resolve?: (_?: ClosedWithType | 'cancel') => void;
    private reject?: (_?: unknown) => void;

    get componentInstance(): DialogType {
        if (!this.contentRef?.componentRef) {
            throw new Error('ModalDialogRef: componentInstance cannot be accessed before dialog is opened.');
        }

        return this.contentRef.componentRef.instance;
    }

    set componentInstance(_: DialogType) {}

    result: Promise<ClosedWithType | 'cancel' | undefined>;

    constructor(
        private windowCompRef: ComponentRef<ModalDialogWindowComponent> | null,
        private contentRef: ModalDialogContentRef<DialogType> | null,
        private overlayCompRef?: ComponentRef<ModalDialogOverlayComponent> | null,
    ) {
        windowCompRef?.instance.dismissEvent.subscribe((reason: unknown) => {
            this.dismiss(reason);
        });

        this.result = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });

        this.result.then(null, () => {});
    }

    close(result?: ClosedWithType | 'cancel'): void {
        if (!this.windowCompRef) {
            return;
        }

        this.resolve?.(result);
        this.removeDialogElements();
    }

    dismiss(reason?: unknown): void {
        if (this.windowCompRef) {
            this.reject?.(reason);
            this.removeDialogElements();
        }
    }

    private removeDialogElements(): void {
        const windowEl = this.windowCompRef?.location.nativeElement as HTMLElement;
        windowEl?.parentNode?.removeChild(windowEl);
        this.windowCompRef?.destroy();

        if (this.overlayCompRef) {
            const overlayEl = this.overlayCompRef.location.nativeElement as HTMLElement;
            overlayEl.parentNode?.removeChild(overlayEl);
            this.overlayCompRef.destroy();
        }

        if (this.contentRef?.viewRef) {
            this.contentRef.viewRef.destroy();
        }

        // this is dangerous and stupid.  those properties are injected as readonly by angular DI
        this.windowCompRef = null;
        this.overlayCompRef = null;
        this.contentRef = null;
    }
}
